/* global axios */
import ApiClient from './ApiClient';

class EmailAntispamAPI extends ApiClient {
  constructor() {
    super('email_antispam_entries', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  create(email) {
    return axios.post(this.url, { email_antispam_entry: { email } });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new EmailAntispamAPI();
